module.exports = __webpack_public_path__ + "img/error.4b0df569.svg";